import React, { Suspense } from 'react';

import type { ComponentProps, JSX } from 'react';

import type { MalwareScanFields } from '../Utilities/attachmentScan';

export interface IJobAttachment extends MalwareScanFields {
  id: number;
  attached_content_type: string;
  attached_file_name: string;
  created_at: string;
  public_link?: string;
  url?: string;
  attached_by?: string;
  updated_at?: string;
  application_link?: string;
  previewable?: boolean;
}

const FilePreviewModalContent = React.lazy(async () => import('./FilePreviewModalContent'));

type FilePreviewModalProps = ComponentProps<typeof FilePreviewModalContent>;

const FilePreviewModal = ({
  previewOpen,
  ...filePreviewModalProps
}: FilePreviewModalProps): JSX.Element | null => {
  if (!previewOpen) return null;

  return (
    <Suspense fallback={null}>
      <FilePreviewModalContent previewOpen={previewOpen} {...filePreviewModalProps} />
    </Suspense>
  );
};

export default FilePreviewModal;
